import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { decodeID, getLastURL } from "../../utils/Helper";
import { FaqDetailsAction, FaqUpdateAction } from "../../Redux/Action/FaqAction";




interface FormInputs {
  answer: string,
  question: string,
  user_type: string,
  edit_id?: string,

}
function FaqManagementEdit() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate()
  const Faqdata = useSelector((state: any) => state.FaqDetailsState?.data?.data)
  const Faqupdatedata = useSelector((state: any) => state.FaqUpdateState)

  const location = useLocation();
  const editId = getLastURL(location);
  const log_in = useSelector((state: any) => state.AdminLogInState)
  const faqstatus = useSelector((state: any) => state.FaqCreatestate)
  const [loading, setLoading] = useState(false)

  const formSchema: any = Yup.object().shape({
    question: Yup.string()
      .required('Please enter question.')
      .trim()
      .min(2, 'question must be more than 2 characters.')
      .max(255, 'question should not exceed 50 characters.'),

    answer: Yup.string()
      .required('Please enter answer.')
      .trim()
      .min(2, 'Answer be more than 2 characters.')
      .max(255, 'question should not exceed 50 characters.'),

    user_type: Yup.string()
      .required('Please enter user type.')
      .trim()


  });
  const { register, formState: { errors }, handleSubmit, watch, setValue } = useForm<FormInputs>({
    resolver: yupResolver(formSchema),
  });
  const onSubmit = (data: FormInputs) => {
    data.edit_id = Faqdata.id
    dispatch(FaqUpdateAction(data))
  };
  useEffect(() => {
    if (Faqupdatedata.status) {
      setTimeout(() => {
        navigate("/faq-list")
      }, 1000);
    }
  }, [Faqupdatedata])

  useEffect(() => {
    setLoading(true)
    var params = {
      detail_id: decodeID(editId)
    };
    dispatch(FaqDetailsAction(params))
    setTimeout(() => {
      setLoading(false)
    }, 400);
  }, [])
  useEffect(() => {
    if (Faqdata) {
      setLoading(false);
      setValue("user_type", Faqdata.user_type);
      setValue("question", Faqdata.question);
      setValue("answer", Faqdata.answer);
    }
  }, [Faqdata, setValue]);
  useEffect(() => {
    return () => {
      dispatch(FaqUpdateAction('RESET'));
    }
  }, [])
  return (
    <Fragment>
      {log_in?.loading ? <Spinner /> : ""}
      <PageLayout
        title="Faq Update"
        breadcrumbs={{
          secLast: { 'link': '/faq-list', 'name': 'Faq' },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >


        <div className="mt-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-4 mb-4 align-items-end">
              <div className="col-md-6">
                <label htmlFor="username" className="form-label">Question</label>
                <input type="text" className="form-control mb-0" id="question" defaultValue={Faqdata?.question} placeholder="Enter Question" {...register("question", {
                  required: "Please enter question.",

                })}
                  onInput={(e: any) => {
                    // e.target.value = e.target.value.replace(/\s/g, '');
                    setValue("question", e.target.value)
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="question"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="username" className="form-label">Answer</label>
                <input type="text" className="form-control mb-0" id="answer" defaultValue={Faqdata?.answer} placeholder="Enter Answer" {...register("answer", {
                  required: "Please enter answer.",

                })}
                  onInput={(e: any) => {
                    // e.target.value = e.target.value.replace(/\s/g, '');
                    setValue("answer", e.target.value)
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="answer"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="user_type" className="form-label">User Type</label>
                <select
                  id="user_type"
                  className="form-control profile-approve-dropdown mb-0"
                  {...register("user_type", {
                    required: "Please select a user type."
                  })}
                  onInput={(e: any) => {
                    setValue("user_type", e.target.value)
                  }}
                >
                  <option value="">Select User Type</option>
                  <option value="Salon" selected={Faqdata?.user_type == "Salon" ? true : false} >Salon</option>
                  <option value="Customer" selected={Faqdata?.user_type == "Customer" ? true : false}  >Customer</option>
                </select>
                <ErrorMessage
                  errors={errors}
                  name="user_type"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-2 col-sm-6 col-12">
                <button type="submit" className="btn btn-primary waves-effect waves-light w-100">SAVE</button>
              </div>
            </div>

          </form>
        </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default FaqManagementEdit